import React from 'react';
import { Form } from 'react-bootstrap';

function InputWithIcon({ icon, placeholder, ...props }) {
    return (
        <div className="input-group">
            <Form.Control placeholder={placeholder} {...props} className="pf-search"/>
            <span className="input-group-text">
            <i className={`bi ${icon}`}></i>
          </span>
        </div>
    );
}

export default InputWithIcon;